import { Model } from '@vuex-orm/core';
import { uuidv4 } from '../../utils/helpers';
import {
  UnitType,
  Order,
  OrderLineStatus,
  TreatmentCategory,
  Product,
  Package,
  Warehouse,
} from './models';

export class OrderLine extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'order_lines';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      order_id: this.attr(null),
      order: this.belongsTo(Order, 'order_id'),
      product_id: this.attr(null),
      product: this.belongsTo(Product, 'product_id'),
      package_id: this.attr(null),
      package: this.belongsTo(Package, 'package_id'),
      quantity: this.attr(null),
      unit_type_code: this.attr(null),
      unit_type: this.belongsTo(UnitType, 'unit_type_code'),
      price: this.attr(null),
      package_quantity: this.attr(null),
      dispatched_at: this.attr(null),
      received_at: this.attr(null),
      dispatching_warehouse_id: this.attr(null),
      dispatching_warehouse: this.belongsTo(Warehouse, 'dispatching_warehouse_id'),
      receiving_warehouse_id: this.attr(null),
      receiving_warehouse: this.belongsTo(Warehouse, 'receiving_warehouse_id'),
      status_code: this.attr('pending'),
      status: this.belongsTo(OrderLineStatus, 'status_code'),
      job_density: this.attr(null),
      job_spec_before: this.attr(null),
      job_spec_required: this.attr(null),
      job_spec_after: this.attr(null),
      job_treatment_category_id: this.attr(null),
      job_treatment_category: this.belongsTo(TreatmentCategory, 'job_treatment_category_id'),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    };
  }
}

export default OrderLine;
